<template>
    <div>
        <template v-if="!videoEmbedTemplate">
            <cp-grid>
                <cp-grid-item span="auto">
                    <cp-text-input v-model="videoUrl" type="text" placeholder="Paste video link here" block></cp-text-input>
                    <template v-if="error">
                        <div style="color: var(--highlight, red)">{{ error.message }}</div>
                    </template>
                </cp-grid-item>

                <cp-grid-item span="3">
                    <cp-button block primary :disabled="loading || !videoUrl" :loading="loading" @click="handleVideoInput">
                        <span>Add video</span>
                    </cp-button>
                </cp-grid-item>
            </cp-grid>
        </template>

        <template v-if="videoEmbedTemplate">
            <div v-html="videoEmbedTemplate"></div>
            <cp-button @click="resetVideo">Remove video</cp-button>
        </template>
    </div>
</template>

<script>
    import TextInput from './text';
    import Grid from '../grid';
    import GridItem from '../grid-item';
    import Button from '../button';
    import { parseVideoUrl, getEmbeddedVideoMarkup, processNewEmbeddedVideos } from '../lib/video';

    export default {
        components: {
            CpTextInput: TextInput,
            CpGrid: Grid,
            CpGridItem: GridItem,
            CpButton: Button,
        },

        props: {
            value: [Object, String],
            emitString: Boolean // Emit the entered string, otherwise it'll be a {source, id} object.
        },

        data() {
            return {
                loading: false,
                error: null,
                videoUrl: null,
                videoEmbedTemplate: null,
            };
        },

        methods: {
            async handleVideoInput() {
                try {
                    this.loading = true;
                    this.error = null;
                    this.$emit('input', this.emitString ? this.videoUrl : parseVideoUrl(this.videoUrl));
                } catch (error) {
                    this.error = error;
                } finally {
                    this.loading = false;
                }
            },

            async displayVideo({source, id}) {
                this.videoEmbedTemplate = await getEmbeddedVideoMarkup(source, id);
                if (source === 'facebook') {
                    await processNewEmbeddedVideos();
                }
            },

            resetVideo() {
                this.$emit('input', null);
            },
        },

        watch: {
            value: {
                handler(value) {
                    if (value) {
                        try {
                            this.error = null;
                            const video = typeof value === 'string' ? parseVideoUrl(value) : value;
                            this.displayVideo(video);
                        } catch (error) {
                            this.error = error;
                        }
                    } else {
                        this.videoUrl = null;
                        this.videoEmbedTemplate = null;
                    }
                },
                immediate: true,
            },
        },
    };
</script>
